import React from 'react';
import {
	Create,
	TextField,
	TextInput,
	SimpleForm,
} from 'react-admin';

import Responses from './components/Responses';


export default (props) => (
	<Create {...props} title="Ответ на Feedback">
		<SimpleForm>
			<TextField label="Просмотр сообщения и ответов" />
			<Responses />
			<TextInput
				label="Введите текст ответа"
				source="message"
				multiline
				style={{ marginTop: '2em', width: '100%' }}
			/>
		</SimpleForm>
	</Create>
);
